const state = {
    suppliers: [
        // {
        //     title: '',
        // }
    ],
    users: [],
};

const mutations = {
    setSuppliers(state, value) {
        state.suppliers = value;
    },
    setUsers(state, value) {
        state.users = value;
    },
};

const actions = {};

const getters = {
    suppliers: (state) => state.suppliers,
    users: (state) => state.users,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
